import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=538b60e4&"
import script from "./AddUserModal.vue?vue&type=script&lang=js&"
export * from "./AddUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538b60e4')) {
      api.createRecord('538b60e4', component.options)
    } else {
      api.reload('538b60e4', component.options)
    }
    module.hot.accept("./AddUserModal.vue?vue&type=template&id=538b60e4&", function () {
      api.rerender('538b60e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ProtectedUrls/AddUserModal.vue"
export default component.exports